import React from "react";
import PageHero from "./components/PageHero";
import ContactSection from "./components/ContactSection";
import Faq from "./components/Faq";

export default function Contato() {
  return (
    <main className="contato">
      <PageHero
        theme="white"
        align="left"
        eyebrow="Fale com a Eniato"
        title={
          <>
            Pronto para uma gestão contábil{" "}
            <strong className="page-hero__title-highlight">estratégica</strong>?
          </>
        }
        text="Nossa equipe de especialistas está pronta para otimizar a saúde financeira e legal da sua empresa, garantindo conformidade e impulsionando seu crescimento."
        primaryButton={{ label: "Solicitar Proposta", href: "#formulario" }}
      />

      <ContactSection />
      <Faq />
    </main>
  );
}
